import React, { useState, useEffect,children } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faHotel, faTaxi, faCalendarAlt, faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import flighticon from '../assets/indigo-svgrepo-com 1.png';
import image1 from '../assets/Vector (5).svg';
import fam1 from '../assets/family-svgrepo-com (1).svg';
import fam2 from '../assets/Group 1082.svg';
import fam3 from '../assets/Vector (5).svg';
import seat from '../assets/Screenshot 2024-08-21 031108 1.png';
import refund from '../assets/refund-svgrepo-com.png';
import rightarrow from '../assets/Line arrow-right (1).png'
import do1 from '../assets/Group 1618873644.svg';
import do3 from  '../assets/Vector (3).svg';
import yes from '../assets/Vector 138.png';
import no from '../assets/maki_cross.png';
import pln1 from '../assets/Group 1618874036.png';
import pln2 from '../assets/Group 1618874037.png';
import do4 from '../assets/Group 1618873984.svg';
import './DetailedOverview.css';


const mockData = {
  
  flights: [
    { id: 1,flightname:'Indigo Airlines',flightnumber:'6E09',pnr:'12345', date: '24/10/24',day:'Thu', from: 'Bengaluru',fromairport:'Kempegowda', fromcode: 'BLR',checkinbag:'15 kg',carryon:'7 kg', to: 'Malaysia',toairport:'Birsa Munda', tocode: 'MAY', airline: 'Indigo',departuredate:'5th oct',arrivaldate:'6th oct', departureTime: '13:10', arrivalTime: '14:40', duration: '2h 30m', rating: 5,refundstatus: 'Refundable',class: 'Economy', flightimg: { flighticon }, refundableicon: '../assets/vector-' },
    { id: 2, date: 'Fri, 25 Oct', from: 'Bengaluru', to: 'Malaysia', airline: 'Indigo', departureTime: '13:10', arrivalTime: '14:40', duration: '26h 30m', rating: 5 },
    { id: 3, date: 'Sat, 26 Oct', from: 'Bengaluru', to: 'Malaysia', airline: 'Indigo', departureTime: '13:10', arrivalTime: '14:40', duration: '26h 30m', rating: 5 },
    { id: 4, date: 'Sun, 27 Oct', from: 'Malaysia', to: 'Bangalore', airline: 'Indigo', departureTime: '13:10', arrivalTime: '14:40', duration: '26h 30m', rating: 5 },
  ],
  hotels: [
    { id: 1, date: 'Thu, 24 Oct', name: 'Luxury Hotel', people: '4 adults', rooms: '10', area: '100', location: 'Kuala Lumpur', checkIn: '24 Oct', checkOut: '27 Oct', roomType: 'Deluxe Suite', rating: 4.5, review: 100, imgUrl: '../assets/India.jpg',amenities: [
      { name: 'Private Pool', available: 'Yes' },
      { name: 'Wifi', available: 'Yes' },
      { name: 'Spa', available: 'No' },
      { name: 'Butler Service', available: 'Yes' }
    ], },
    { id: 2, name: 'Beach Resort', location: 'Langkawi', checkIn: '27 Oct', checkOut: '30 Oct', roomType: 'Ocean View', rating: 4.7, imgUrl: 'path/to/hotel/image2.jpg' },
  ],
  activities: [
    { id:1,date: 'Thu, 24 Oct',morning:'full act',afternoon:'Add activity',Evening:'Add activity' },
    { id: 2, name: 'Batu Caves Visit', duration: '3 hours', location: 'Selangor', rating: 5 },
  ],
  transfers: [
    { id: 1, date: 'Thu, 24 Oct',start:'goa',end:'gao', type: 'Airport Transfer', from: 'KLIA Airport', to: 'Luxury Hotel',description:'hotel transfer', vehicleType: 'Sedan', rating: 5,etd: 'Evening', },
    { id: 2, type: 'Hotel Transfer', date: '27 Oct', from: 'Luxury Hotel', to: 'Beach Resort', vehicleType: 'Minivan', rating: 5 },
  ],
  extraactivity:[
    {id:1,activityname:'Boating'},
    {id:2,activityname:'Washing'},
    {id:3,activityname:'Balling'},
    {id:4,activityname:'Eating'}
  ]
};

const fetchData = async (type) => {
  try {
    const response = await fetch(`/api/${type}`);
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error('Error fetching data:', error);
    return mockData[type];
  }
};



const DetailedOverview = () => {
  const [activeTab, setActiveTab] = useState('flights');
  const [data, setData] = useState([]);
  const [showAddActivityModal, setShowAddActivityModal] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      const fetchedData = await fetchData(activeTab);
      setData(fetchedData);
    };
    loadData();
  }, [activeTab]);
  
  const handleAddActivity = () => {
    setShowAddActivityModal(true);
  };

  const handleCloseModal = () => {
    setShowAddActivityModal(true);
  };

  const AddActivity = () => {
    if (!showAddActivityModal) return null;

    return (
      <div className="modal-overlay">
        <div className="modal">
          <button className="close-button" onClick={handleCloseModal}>
            &times; 
          </button>
          <h2>Add New Activity</h2>
          <p>Here you can add your new activity details.</p>
          <button onClick={handleCloseModal}>Submit Activity</button>
        </div>
      </div>
    );
  };

  const StarRating = ({ rating }) => {
    const validRating = Math.max(0, Math.min(rating, 5));
    const fullStars = Math.floor(validRating);
    const halfStar = validRating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(validRating);

    return (
      <div className="star-rating">
        {Array(fullStars).fill().map((_, index) => (
          <FontAwesomeIcon key={`full-${index}`} icon={faStar} style={{ color: 'gold' }} />
        ))}
        {halfStar && <FontAwesomeIcon icon={faStarHalfAlt} style={{ color: 'gold' }} />}
        {Array(emptyStars).fill().map((_, index) => (
          <FontAwesomeIcon key={`empty-${index}`} icon={faStar} style={{ color: 'lightgray' }} />
        ))}
      </div>
    );
  };


  const renderFlightItem = (flight) => (
    <div key={flight.id} className="card">
      <div className="card-content">
        <img src={do1} style={{ position: 'absolute', zIndex: '3', left: '-15px', top: '50%' }} alt="" />
        <div className="flex-between">
          <div className="flex-start">
            <p className="font-bold">{flight.day},<br></br>{flight.date}</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column',width:'100%' }}>
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' ,justifyContent:'space-between',width:'100%'}}>
                <div>
                <div style={{ fontSize: '150%', fontWeight: '700' ,margin:'auto'}}>{flight.from} → {flight.to}</div>
                </div>
                <div>
                <div style={{ fontSize: '80%', display: 'flex', flexDirection: 'row',margin:'auto'}}>
                <div style={{ margin: '10px' }}><img src={refund}/> {flight.refundstatus}</div>
                <div style={{ margin: '10px' }}><img src={seat}/> {flight.class}</div>
              </div>
                </div>
                <div>
                <div style={{margin:'auto',fontWeight:'500'}}>PNR: {flight.pnr}</div>
                </div>
              </div>
              

              <div style={{ color: '#2495F1', fontSize: '80%' ,fontWeight: '600'}}>{flight.date}</div>

              <div style={{ display: 'flex', flexDirection: 'row', width: '100%',justifyContent:'space-between'}}>
                <div>
                </div>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                  <img style={{width:'auto',height:'70px'}}src={flighticon} alt="" />
                  <div style={{display:'flex',flexDirection:'column',padding:'15px'}}>
                    <div style={{fontWeight:'bold'}}>{flight.flightname}</div>
                    <div>{flight.flightnumber}</div>
                    <div><img src='../assets/mdi_bag-personal.svg'/>{flight.checkinbag} Check-In</div>
                    <div><img src='../assets/travel-svgrepo-com.svg'/>{flight.carryon}  Carry On</div>
                  </div>
                </div>
                <div style={{padding:'15px'}}>
                  <div>{flight.departureTime},{flight.date}</div>
                  <div>{flight.from}-{flight.fromcode}</div>
                  <div>{flight.fromairport}</div>
                </div>
                <div>

              
              <div style={{textAlign:'center'}}>{flight.duration}</div>
              <div style={{display:'flex',flexDirection:'row'}}>
                <div ><img src={pln1}/></div>
                <div className='blue-line'></div>
                <div ><img src={pln2}/></div>
              </div>
              <div style={{textAlign:'center'}}>Non-stop</div>
              </div>
              
              <div style={{padding:'15px'}}>
                  <div>{flight.arrivalTime},{flight.date}</div>
                  <div>{flight.to}-{flight.tocode}</div>
                  <div>{flight.toairport}</div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderHotelItem = (hotel) => (
    
    <div key={hotel.id} className="card">
      <img src={image1} style={{ position:'absolute',zIndex:'3', left: '-15px', top: '50%' }} alt="hi" />
      
      <div className="hotel-details" style={{width:'100%',padding:'15px', display: 'flex', flexDirection: 'row', border: 'solid 1px', borderRadius: '10px' }}>
      
        <div className="flex-start">
        
        <p className="font-bold">{hotel.date},<br></br></p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="hotel-title">{hotel.name}
            <div className='booking-id'>Booking ID: {hotel.bookingid}</div>
          </div>
          <div className="hotel-content"> 
            <img src={hotel.imgUrl} alt="Hotel" style={{width:'40%',borderRadius:'15px',height:'auto'}} />
            
            <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
              <div className="hotel-meta">
                <div className="hotel-rating">
                  <div>{hotel.rating}/5 ( {hotel.review} )</div>
                  <div><StarRating rating={parseFloat(hotel.rating)} /></div>
                  <div><img src={refund}/>refundable</div>
                </div>
              </div>
              <div className="hotel-meta">
                <div className="hotel-det">
                  <div><img src={fam1}/> {hotel.people}</div>
                  <div><img src={fam2}/>Rooms: {hotel.rooms}</div>
                  <div><img src={fam3}/>Area: {hotel.area}</div>
                </div>
              </div>
              <div  className='ver-line'></div>
                <div>
                  <ul className="amenities" style={{ display: 'flex',flexDirection:'row', justifyContent: 'space-between',padding:'30px' }}>
                    {hotel.amenities?.map((amenity, index) => (
                      <li key={index} style={{ display: 'flex',flexDirection:'row', alignItems: 'center' }}>
                        {amenity.available === 'Yes' ? (
                          <img src={yes} alt="Available" style={{ height: '20px', marginRight: '5px' }} />
                        ) : (
                          <img src={no} alt="Not Available" style={{ height: '20px', marginRight: '5px' }} />
                        )}
                        {amenity.name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderActivityItem = (activity) => (
    <div key={activity.id} className="card">
      <img src={do3} style={{ position: 'absolute', zIndex: '3', left: '-15px', top: '50%' }} alt="" />
      <div className="card-content">
        <div className="flex-between">
          <div className="flex-start">
            <p className="font-bold">{activity.date}</p>
          </div>
          <div className='dp-table'>
            <div style={{borderRight: 'solid 1px #777777'}}>
              <div style={{ borderBottom: 'solid 1px #777777', padding: '20px' }}>MORNING</div>
              {
                activity.morning === 'Add activity' 
                  ? <div style={{ padding: '20px', cursor: 'pointer' }} onClick={handleAddActivity}>Add activity</div> 
                  : <div style={{ padding: '20px' , cursor: 'pointer'}} onClick={handleAddActivity}>
                    {activity.morning}<br></br>Booking id: {activity.id}</div>
              }
              <AddActivity />
            </div>
            <div style={{borderRight: 'solid 1px #777777' }}>
              <div style={{ borderBottom: 'solid 1px #777777', padding: '20px'}}>AFTERNOON</div>
              {
                activity.afternoon === 'Add activity' 
                  ? <div style={{ padding: '20px', cursor: 'pointer' }} onClick={handleAddActivity}>Add activity</div> 
                  : <div style={{ padding: '20px'}} onClick={handleAddActivity}>{activity.afternoon}</div>
              }
              <AddActivity />
            </div>
            <div>
              <div style={{ borderBottom: 'solid 1px #777777', padding: '20px'}}>EVENING</div>
              {
                activity.Evening === 'Add activity' 
                  ? <div style={{ padding: '20px', cursor: 'pointer' }} onClick={handleAddActivity}>Add activity</div> 
                  : <div style={{ padding: '20px',  }} onClick={handleAddActivity}>{activity.Evening}</div>
              }
              <AddActivity />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  

  const renderTransferItem = (transfer) => (
    <div key={transfer.id} className="card">
      <img src={do4} style={{ position: 'absolute', zIndex: '3', left: '-15px', top: '50%' }} alt="" />
      <div className="card-content">
        <div className="flex-between">
          <div className="flex-start">
            <p className="font-bold">{transfer.date}</p>
          </div>
          <div style={{display:'flex',flexDirection:'row',width:'80%',border:'solid 1px #541C9C',borderRadius:'15px'}}>
            <div style={{display:'flex',flexDirection:'column',width:'50%',borderRight:'solid 1px black',padding:'15px'}}>
              <div style={{fontSize:'150%',fontWeight:'500'}}>{transfer.type}</div>
              <br></br>
              <div style={{color:'#777777',fontWeight:'500'}}>Booking Id: {transfer.id}</div>
              <div style={{color:'#777777',fontWeight:'500'}}>Description: {transfer.description}</div>
              <div style={{color:'#777777',fontWeight:'500'}}>ETD: {transfer.etd}</div>
            </div>
            <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
              <div style={{display:'flex',flexDirection:'row',borderBottom:'solid 1px black',padding:'15px'}}>
                <p style={{fontSize:'150%',fontWeight:'500'}}>{transfer.from}<img src={rightarrow}/>{transfer.to}</p>
              </div>
              <div style={{display:'flex',flexDirection:'column',borderRadius:'15px',padding:'15px'}} >
                <div style={{color:'#777777',fontWeight:'500'}}>start:{transfer.start}</div>
                <div style={{color:'#777777',fontWeight:'500'}}>end:{transfer.end}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  

  const renderItems = () => {
    switch (activeTab) {
      case 'flights':
        return data.map(renderFlightItem);
      case 'hotels':
        return data.map(renderHotelItem);
      case 'activities':
        return data.map(renderActivityItem);
      case 'transfers':
        return data.map(renderTransferItem);
      default:
        return null;
    }
  };

  return (
    <div className="detailed-overview">
      <div style={{border:'solid 2px #541C9C',borderRadius:'15px'}}>
        <div className='do-title'>Detailed Overview</div>
      <div style={{padding:'15px'}}>


      <div className="tab-container">
        {['flights', 'hotels', 'activities', 'transfers'].map((tab) => (
          <button key={tab} className={activeTab === tab ? 'tab-do-active' : 'tab-do'} onClick={() => setActiveTab(tab)}>
            {tab}
          </button>
        ))}
      </div>
      <div className="tab-content">{renderItems()}</div>
      </div>
      </div>
      
    </div>
  );
};

export default DetailedOverview;
